// mesbot/src/institution/pages/Wellness.js
import React, { useEffect, useState } from "react";
import { getWellness } from "../api";

const TOPIC_COLORS = {
  topic_stress_pct: "#f59e0b",
  topic_anxiety_pct: "#7c3aed",
  topic_loneliness_pct: "#ec4899",
  topic_academic_pct: "#4f46e5",
  topic_other_pct: "#9ca3af",
};
const TOPIC_LABELS = {
  topic_stress_pct: "Stress",
  topic_anxiety_pct: "Anxiety",
  topic_loneliness_pct: "Loneliness",
  topic_academic_pct: "Academic",
  topic_other_pct: "Other",
};

export default function Wellness({ token }) {
  const [snapshots, setSnapshots] = useState([]);
  const [weeks, setWeeks] = useState(8);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    getWellness(token, weeks)
      .then(setSnapshots)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [token, weeks]);

  const sorted = [...snapshots].reverse();
  const maxSessions = Math.max(...sorted.map(s => s.total_sessions), 1);

  return (
    <>
      <div className="inst-page-title">Wellness Temperature</div>
      <div className="inst-page-subtitle">Daily session volume and topic trends</div>

      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        {[4, 8, 12].map(w => (
          <button
            key={w}
            className={`inst-btn ${weeks === w ? "inst-btn-primary" : "inst-btn-ghost"}`}
            onClick={() => setWeeks(w)}
          >
            {w} weeks
          </button>
        ))}
      </div>

      {error && <div className="inst-error">{error}</div>}

      <div className="inst-panel" style={{ marginBottom: 16 }}>
        <div className="inst-panel-title">Session Volume</div>
        <div className="inst-panel-subtitle">{sorted.length} days shown</div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: 3,
            height: 100,
            overflowX: "auto",
            paddingBottom: 4,
          }}
        >
          {sorted.length === 0 && !loading && (
            <div className="inst-no-data">No data for this period</div>
          )}
          {sorted.map(snap => {
            const h = (snap.total_sessions / maxSessions) * 90;
            const stressed = (snap.topic_stress_pct || 0) + (snap.topic_anxiety_pct || 0);
            const color = stressed >= 50 ? "#f59e0b" : snap.topic_stress_pct === null ? "#9ca3af" : "#4ade80";
            return (
              <div key={snap.snapshot_date} className="inst-bar-col" style={{ minWidth: 10 }}>
                <div
                  className="inst-bar"
                  style={{ height: h || 4, background: color }}
                  title={`${snap.snapshot_date}: ${snap.total_sessions} sessions`}
                />
                <div className="inst-bar-label" style={{ fontSize: 7 }}>
                  {new Date(snap.snapshot_date).getDate()}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="inst-panel">
        <div className="inst-panel-title">Topic Breakdown by Day</div>
        <div className="inst-panel-subtitle">NULL fields shown as "—" (N &lt; 5 suppression)</div>
        <div style={{ overflowX: "auto" }}>
          <table className="inst-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Sessions</th>
                <th>Active</th>
                {Object.keys(TOPIC_LABELS).map(k => (
                  <th key={k}>{TOPIC_LABELS[k]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...sorted].reverse().map(snap => (
                <tr key={snap.snapshot_date}>
                  <td>{snap.snapshot_date}</td>
                  <td>{snap.total_sessions}</td>
                  <td>{snap.active_users}</td>
                  {Object.keys(TOPIC_LABELS).map(k => (
                    <td key={k}>
                      {snap[k] !== null && snap[k] !== undefined
                        ? `${snap[k]}%`
                        : <span className="inst-no-data">—</span>}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
